import { Accordion, Badge, Text } from "../../../../elements";
import { useNavbar } from "../../hooks";
import { NavbarLinksMobileIcon } from "./navbar-links-mobile-icon.component";

import styles from "./navbar-links-mobile-item.module.css";

type Link = {
  label: string;
  dataQA: string;
  href: string;
  icon: string;
  iconViewBox: string;
  isNew?: boolean;
};

type Section = {
  label: string;
  dataQA: string;
  isNew?: boolean;
  links: Link[];
};

export function NavbarLinksMobileItem({
  section,
}: Readonly<{ section: Section }>) {
  const { shouldOpenInSameWindow } = useNavbar();
  const linkTarget = shouldOpenInSameWindow ? undefined : "_blank";

  return (
    <Accordion.Item key={section.label} defaultOpen={false}>
      <div data-qa={section.dataQA} className={styles.MenuItem}>
        <Accordion.Header>
          <div className={styles.IsNewWrapper}>
            <Text variant="body-regular-medium">{section.label}</Text>
            {section.isNew && (
              <Badge isOutlined text="NOVO" size="small" variant="primary" />
            )}
          </div>
        </Accordion.Header>
        <div className={styles.LinkList}>
          <Accordion.Body>
            <div className={styles.LinkListWrapper}>
              {section.links.map((link: Link) => (
                <Text
                  key={link.label}
                  as="a"
                  className={styles.Link}
                  data-qa={link.dataQA}
                  href={link.href}
                  target={linkTarget}
                  variant="body-regular-medium"
                >
                  {link.icon && (
                    <NavbarLinksMobileIcon
                      iconName={link.icon}
                      viewBox={link.iconViewBox || "0 0 24 24"}
                    />
                  )}
                  {link.label}
                  {link.isNew && (
                    <Badge
                      isOutlined
                      text="NOVO"
                      size="small"
                      variant="primary"
                    />
                  )}
                </Text>
              ))}
            </div>
          </Accordion.Body>
        </div>
      </div>
    </Accordion.Item>
  );
}
